<template>
  <div class="page-header-wrapper">
    <div class="page-header-illustration">
      <IllustrationsOnboarding1 />
    </div>
    <h1>{{ $t("bnpl:b2b.kyc.intro.title") }}</h1>
    <p>{{ $t("bnpl:b2b.kyc.intro.subtitle") }}</p>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.btn {
  // width: 100%;
  flex: 0;
  padding-inline: 120px;
  max-width: 100%;
}
</style>